import { FormTypes } from '../../../components/FormGenerator';
import VenueRegistrationFormModal from '../shared/VenueRegistrationFormModal';

class PoliciesModal extends VenueRegistrationFormModal {
	constructor() {
		const isMultisite = !!document.querySelector('.p-venue-registeration-landing-multisite-with-venue');

		super({
			modalSelector: '#policies-form-modal',
			triggerSelectors: ['.js-policies-trigger'],
			stepsEndpointAttr: 'policies-steps-endpoint',
			submitEndpointAttr: 'policies-submit-endpoint',
			wrapperSelector: isMultisite
				? '.p-venue-registeration-landing-multisite-with-venue'
				: '.p-venue-registration-landing',
			sectionWrapperSelector: '.p-venue-registration-landing-wrapper',
			logPrefix: 'PoliciesModal'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: 1,
			formType: FormTypes.SectionForm,
			isExitButtonEnabled: true,
			exitButtonLabel: 'Exit',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue',
				alwaysVisible: true
			}
		};
	}
}

VenueRegistrationFormModal.boot(PoliciesModal);

export default PoliciesModal;
